<template>
  <AbsPopup id="PublishingStore" title="출간일 선택" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div v-for="(item, index) in list" :key="index">
          <li>
            <span>{{ Store.toString(item.bookstore) }}</span>
          </li>
          <li>
            <Ubutton type="text" :class="{active: item.start}" :text="getStart(item)" :disabled="itemDisabled(item)" @click="openCalendar($event.target, new Date(item.date), (time) => {
              item.start = new Date(time)
              list.push(list.pop())
            })"/>
            <span> - 종료일</span>
          </li>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import {Store, timeToDateString} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.option.param) {
      console.log(this.option.param)
      this.list = this.option.param.item.publication.store
      this.$emit('loading', false)
    }
  },
  data () {
    return {
      Store: Store,
      list: null
    }
  },
  name: 'PublishingStore',
  computed: {
  },
  methods: {
    getStart (item) {
      console.log(item)
      return (item.confirm) ? timeToDateString(item.confirm) : (item.start ? timeToDateString(item.start) : timeToDateString(item.date))
    },
    itemDisabled (item) {
      if (this.option.param.view) {
        return this.option.param.view
      } else if (this.option.param.edit) {
        return Boolean(item.confirm)
      } else {
        return false
      }
    },
    submit () {
      this.$emit('close')
    }
  },
  components: {
    AbsPopup
  }
}
</script>

<style scoped>
#PublishingStore {
  padding: 10px 0;
  width: 400px;
}
.popup-body {
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
}
.popup-body > div {
  display: flex;
  flex-direction: row;
  list-style: none;
  line-height: 40px;
  align-items: center;
  border-bottom: 1px solid var(--line-base);
  padding: 0px 20px;
  margin-top: 20px;
}
.popup-body > div > li:last-child {
  margin-left: auto;
  color: var(--text-base);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/PublishingStore.vue